import { SaveLocationsDocument } from '~/client/graph/operations/generated/Locations.generated'

import MapViewLocationIcon from '../../enums/SitemapAttributeIcon'
import ProjectLocation from '../../models/LocationObjects/ProjectLocation'
import ILocationAttributeDto from '../../types/ILocationAttributeDto'
import LocationBaseStore from './LocationBase.store'

export const DEFAULT_PROJECT_LOCATION_COLOR = '#FF5733'
export default class ProjectLocationsStore extends LocationBaseStore<ProjectLocation> {
  protected saveMutation = SaveLocationsDocument
  protected graphName = 'locations'
  protected defaultIconName: MapViewLocationIcon = MapViewLocationIcon.Project

  public get byId() {
    return this.eventsStore.appState.projectLocations
  }

  protected fromDto(dto: ILocationAttributeDto): ProjectLocation {
    return ProjectLocation.fromDto(dto)
  }

  protected model = ProjectLocation
  protected graphqlTypeName = 'projects'
}
